<div class="header_tabla">
	<h3>{{ dataTable.title }}</h3>
	<app-buttons-reports [dataReport]="dataTable"></app-buttons-reports>
</div>

<div class="table-responsive custom-table-responsive">
	<table class="table custom-table">
		<thead>
			<tr>
				<ng-container *ngFor="let header of dataTable.headers; let i = index">
					<th
						scope="col"
						[ngClass]="{
							right_moneda: getConfig(i) !== null && getConfig(i)!.textAlign === 'right',
							centrar_todo: getConfig(i) !== null && getConfig(i)!.textAlign === 'center'
						}"
						*ngIf="getConfig(i) === null || getConfig(i)!.hidden === undefined || getConfig(i)!.hidden === false"
						[innerHtml]="header"
					></th>
				</ng-container>
			</tr>
		</thead>
		<tbody>
			<ng-container *ngFor="let data of dataTable.data">
				<tr scope="row" class="ver-detalle-ahorro" (click)="clickItem(data)">
					<ng-container *ngFor="let item of $any(data) | keyvalue: originalOrder; let i = index">
						<td
							[ngClass]="{
								row: i === 0,
								nro_cuenta: i === 0 && getConfig(i) !== null && getConfig(i)!.boldBlue === true,
								moneda_dolar_color: item.value === 'US$',
								right_moneda: getConfig(i) !== null && getConfig(i)!.textAlign === 'right',
								centrar_todo: getConfig(i) !== null && getConfig(i)!.textAlign === 'center',
								saldo_disponible: i !== 0 && getConfig(i) !== null && getConfig(i)!.boldBlue === true,
								importe_negativo: isNumber(item.value) && isNegative(item.value)
							}"
							*ngIf="getConfig(i) === null || getConfig(i)!.hidden === undefined || getConfig(i)!.hidden === false"
						>
							{{
								isNumber(item.value)
									? item.value
									: isFieldCard(item.key)
									? ''
									: isCurrency(item.value)
									? transformCurrency(item.value)
									: item.value
							}}
							<img
								*ngIf="getConfig(i) !== null && getConfig(i)!.showIconDolar === true && getNumberCard(data)"
								src="assets/images/icon_tarjeta.png"
							/>
						</td>

						<td
							*ngIf="
								getConfig(i + 1) !== null &&
								getConfig(i + 1)!.showButton === true &&
								getConfig(i + 1)!.textButton === undefined
							"
							class="centrar_todo"
						>
							<a class="ver_detalle_ahorro"></a>
						</td>

						<td
							*ngIf="
								getConfig(i + 1) !== null &&
								getConfig(i + 1)!.showButton === true &&
								getConfig(i + 1)!.textButton !== undefined
							"
							class="centrar_todo"
						>
							<a class="btn_pagar">{{ getConfig(i + 1)!.textButton }} </a>
						</td>
					</ng-container>
				</tr>

				<tr class="spacer">
					<td colspan="100"></td>
				</tr>
			</ng-container>

			<tr
				scope="row"
				class="subtotal_tabla"
				*ngIf="dataTable.subtotalSoles !== undefined && dataTable.subtotalSoles.totals.length"
			>
				<ng-container *ngFor="let header of getIterator(true); let last = last">
					<ng-template #rowEmty>
						<td></td>
					</ng-template>
					<ng-container *ngIf="last; else rowEmty">
						<td class="right_moneda">
							<strong>SUB TOTAL SOLES</strong>
						</td>
						<td class="right_moneda" *ngFor="let total of dataTable.subtotalSoles.totals">
							{{ total }}
						</td>
					</ng-container>
				</ng-container>
			</tr>

			<tr
				scope="row"
				class="subtotal_tabla"
				*ngIf="dataTable.subtotalDolares !== undefined && dataTable.subtotalDolares.totals.length"
			>
				<ng-container *ngFor="let header of getIterator(false); let last = last">
					<ng-template #rowEmty>
						<td></td>
					</ng-template>
					<ng-container *ngIf="last; else rowEmty">
						<td class="right_moneda">
							<strong>SUB TOTAL DÓLARES</strong>
						</td>
						<td class="right_moneda" *ngFor="let total of dataTable.subtotalDolares.totals">
							{{ total }}
						</td>
					</ng-container>
				</ng-container>
			</tr>
		</tbody>
	</table>
</div>
